import * as yup from 'yup';
import { medicareInsuranceEntrySchema } from './medicareInsuranceEntry.schema';
import { otherInsuranceEntrySchema } from './otherInsuranceEntry.schema';

export const otherInsuranceEntriesSchema = yup
  .array()
  .of(otherInsuranceEntrySchema)
  .required();

export const otherInsuranceFormSchema = yup.object({
  entries: otherInsuranceEntriesSchema,
});

export const insuranceFormSchema = yup.object({
  primary_medicare: yup.array().of(medicareInsuranceEntrySchema).required(),
  primary_other: otherInsuranceEntriesSchema,
  secondary: otherInsuranceEntriesSchema,
});

export type InsuranceFormShape = yup.InferType<typeof insuranceFormSchema>;
export type MedicareEntryFormShape = yup.InferType<
  typeof medicareInsuranceEntrySchema
>;
export type OtherInsuranceEntryFormShape = yup.InferType<
  typeof otherInsuranceEntrySchema
>;
